angular.module('comment', ['core'])
    .component('lastComment', {
        bindings: {
            objectType: '<',
            objectId: '<'
        },
        templateUrl: 'app/comment/comment.html',
        controller: function ($scope, $rootScope, $http) {
            this.$onInit = () => {
                this.isLoading = true;
                this.$promise = $http.get('/crm/api/' + this.objectType.toLowerCase() + '/' + this.objectId + "/last-comment")
                    .then(success => this.item = success.data || null)
                    .catch(error => this.item = null)
                    .finally(() => this.isLoading = false);
            }

            this.switchDateFormat = () => {
                this.dateFormat = this.dateFormat == null? "medium" : (this.dateFormat === 'medium' ? 'mediumDate' : null);
            }

            //refresh on comment added only if it's the same object
            // $scope.$on('document.comments.added', (event, data) => {
            //     if (data.objectId === this.objectId) {
            //         this.$onInit();
            //     }
            // }

        }
    })
